/**
 * Created by CoolGuy on 2017/6/16.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
    } = Ajax;
const TheApi = API('gallery');
const GALLERY_ADD = "GALLERY_ADD";
const GALLERY_LIST = "GALLERY_LIST";
const GALLERY_EDIT = "GALLERY_EDIT";
const GALLERY_DETAIL = "GALLERY_DETAIL";
const GALLERY_REMOVE = "GALLERY_REMOVE";
const GALLERY_PARENT = "GALLERY_PARENT";
const GALLERY_EXPORT = "GALLERY_EXPORT";
const GALLERY_SEARCH = "GALLERY_SEARCH";
const GALLERY_CHILDREN = "GALLERY_CHILDREN";
const GALLERY_RESET_WATERMARK = "GALLERY_RESET_WATERMARK";
const GALLERY_CHILD_STAT = "GALLERY_CHILD_STAT";
const GALLERY_VIEW_EDIT = "GALLERY_VIEW_EDIT";
const GALLERY_CONFIG_DETAIL = "GALLERY_CONFIG_DETAIL";
const GALLERY_CONFIG_UPDATE = "GALLERY_CONFIG_UPDATE";
const GALLERY_ORIGIN_INFO = "GALLERY_ORIGIN_INFO";
const GALLERY_DEVICE_LIST = "GALLERY_DEVICE_LIST";

//import {User} from '../util/TestData';
//const mock = User;

export default {
    GALLERY_ADD,
    galleryAdd: (one)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:one,
            success: (data)=>({
                type:GALLERY_ADD,
                data
            })
        })
    },
    GALLERY_LIST,
    gallerys: (search)=>{
        search.page = typeof search.page != 'undefined' ? search.page : (search.current || 1);//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api:TheApi('get')(),
            data:search,
            success: (data)=>({
                type:GALLERY_LIST,
                data
            })
        })
    },
    GALLERY_EDIT,
    galleryEdit: (galleryId,info)=>{
        return ajaxCommon({
            api:TheApi('put')(galleryId),
            data:info,
            success: (data)=>({
                type:GALLERY_EDIT,
                data
            })
        })
    },
    GALLERY_DETAIL,
    GALLERY_PARENT,
    galleryParent:function(galleryId, params) {
        return this.galleryDetail(galleryId, params, true);
    },
    galleryDetail:(galleryId, params, isParent)=>{
        /*eslint eqeqeq:0*/
        if(galleryId == 0) {
            return {
                type:isParent ? GALLERY_PARENT : GALLERY_DETAIL,
                galleryId:0,
                data:params || {}
            };
        }
        return ajaxCommon({
            api:TheApi('get')(galleryId),
            success:(data)=>({
                type:isParent ? GALLERY_PARENT : GALLERY_DETAIL,
                galleryId,
                data
            })
        })
    },
    GALLERY_REMOVE,
    galleryRemove:(galleryId)=>{
        return ajaxCommon({
            api:TheApi('delete')(galleryId),
            success:(data)=>({
                type:GALLERY_REMOVE,
                galleryId,
                data
            })
        })
    },
    GALLERY_RESET_WATERMARK,
    galleryResetWatermark:(galleryid)=>{
        return ajaxCommon({
            api:{
                url:'/api/gallery/resetwatermark',
                method:'get'
            },
            data:{
                galleryid
            },
            success:(data)=>({
                type:GALLERY_RESET_WATERMARK,
                data
            })
        })
    },
    GALLERY_EXPORT,
    galleryExport:(galleryid, dataType = 'file', filter='{}')=>{
        let params = {};
        if(typeof filter == 'object') {
            params = filter;
        }else {
            params = JSON.parse(filter);
        }
        return ajaxCommon({
            api:{
                url:'/api/gallery/export',
                method:'get'
            },
            data:{
                galleryid,
                dataType,
                ...params,
            },
            success:(data)=>({
                type:GALLERY_EXPORT,
                data
            })
        })
    },
    GALLERY_SEARCH,
    gallerySearch:(opt)=>{
        return ajaxCommon({
            api:TheApi('get')('search'),
            data:opt,
            success:(data)=>({
                type:GALLERY_SEARCH,
                data,
            })
        })
    },
    GALLERY_CHILDREN,
    galleryChildren:(opt)=>{
        return ajaxCommon({
            api:TheApi('get')('children'),
            data:opt,
            success:(data)=>({
                type:GALLERY_CHILDREN,
                data,
            })
        })
    },
    GALLERY_CHILD_STAT,
    galleryChildStat:(opt)=>{
        return ajaxCommon({
            api:TheApi('get')('childstat'),
            data:opt,
            success:(data)=>({
                type:GALLERY_CHILD_STAT,
                data
            })
        });
    },
    GALLERY_VIEW_EDIT,
    galleryViewEdit:(id, opt)=>{
        return ajaxCommon({
            api:TheApi('post')('editview'),
            data:{
                id,
                ...opt
            },
            success:(data)=>({
                type:GALLERY_VIEW_EDIT,
                data
            })
        });
    },
    GALLERY_CONFIG_DETAIL,
    galleryConfigDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')('config'),
            data:{
                id
            },
            success:(data)=>({
                type:GALLERY_CONFIG_DETAIL,
                data
            })
        })
    },
    GALLERY_CONFIG_UPDATE,
    galleryConfigUpdate:(data)=>{
        return ajaxCommon({
            api:TheApi('post')('config'),
            data:data,
            success:(data)=>({
                type:GALLERY_CONFIG_UPDATE,
                data
            })
        });
    },
    GALLERY_ORIGIN_INFO,
    galleryOriginInfo:(orderid)=>{
        return ajaxCommon({
            api:TheApi('get')('origin'),
            data:{
                orderid
            },
            success:(data)=>({
                type:GALLERY_ORIGIN_INFO,
                data
            })
        })
    },
    GALLERY_DEVICE_LIST,
    galleryDeviceList:(orderid, withDetail = false)=>{
      return ajaxCommon({
          api:TheApi('get')('devicelist'),
          data:{
              orderid,
              _with_detail:!!withDetail ? 1 : 0
          },
          success:(data)=>({
              type:GALLERY_DEVICE_LIST,
              data
          })
      })
    }
}



// WEBPACK FOOTER //
// ./src/actions/GalleryAction.js